"use strict";
// Copyright 2021 The Prometheus Authors
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
Object.defineProperty(exports, "__esModule", { value: true });
exports.VectorMatchCardinality = exports.Matcher = exports.getFunction = exports.ValueType = void 0;
var function_1 = require("./function");
Object.defineProperty(exports, "ValueType", { enumerable: true, get: function () { return function_1.ValueType; } });
Object.defineProperty(exports, "getFunction", { enumerable: true, get: function () { return function_1.getFunction; } });
var matcher_1 = require("./matcher");
Object.defineProperty(exports, "Matcher", { enumerable: true, get: function () { return matcher_1.Matcher; } });
var vector_1 = require("./vector");
Object.defineProperty(exports, "VectorMatchCardinality", { enumerable: true, get: function () { return vector_1.VectorMatchCardinality; } });
//# sourceMappingURL=index.js.map